// Public/marketing surfaces that skip the authed chrome (sync pill, debug
// panels, update toast). Kept aligned with isPublicPath in ClientLayoutRouter.tsx.
const MARKETING_EXACT = new Set([
  '/', '/login', '/register', '/setup-password', '/confirm-email', '/agb',
  '/impressum', '/datenschutz', '/rechtliches',
])
// `/checkout` renders its own header and "back to the homepage" links — it was
// designed as a standalone public page, not an authed app surface, and pairs
// with the PUBLIC_PREFIXES entry in spa/lib/authGuard.ts.
const MARKETING_PREFIXES = ['/ticket-submit', '/board-link', '/checkout', '/slides', '/landing2', '/landing3', '/landing4']

export function isMarketingPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  if (MARKETING_EXACT.has(pathname)) return true
  return MARKETING_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}
